// extracted by mini-css-extract-plugin
export default {"banner":"RecallBanner_banner__GsYlr","inner":"RecallBanner_inner__Tsdpi container_container__142Ew","link":"RecallBanner_link__OwRH8"};